// src/images/index.js
import AlabamaAg from "../images/home/AlabamaAgScreenshot.jpg";
import Jolly from "../images/home//JollyScreenshot.jpg";
import Oxford from "../images/home/Oxford.png";
import SmartFusion from "../images/home/SmartFusion.png";
import Sunshine from "../images/home/Sunshine.png";
import Marines from "../images/home/MarinesHero.png";
import Shapiro from "../images/home/ShapiroHome.png";
import BREN from "../images/home/BRENDirectory.png";
import WelcomeTable from "../images/home/WelcomeTable.png";
import UA_Edu from "../images/home/UA_education.png";
import BWPWS from "../images/home/BWPWS.png";
import Portland from "../images/home/Portland.jpg";
import JP from "../images/home/JPConstruction.png";
import ARSEA from "../images/home/ARSEA.png";
import Barndo from "../images/home/HomesteadBarn.png";
import Placeholder from "../images/Placeholder.png"

// export const images = {
//   AlabamaAg,
//   Jolly,
//   Oxford,
//   SmartFusion,
//   Sunshine,
//   Marines,
//   Shapiro,
//   BREN,
//   WelcomeTable,
//   UA_Edu,
//   BWPWS,
//   Portland,
// };

export const images = {
    Placeholder: {
        image: Placeholder,
        alt: ""
    },
    AlAg: {
        image: AlabamaAg,
        alt: "A screenshot of the Alabama Ag's homepage."    
    },
    Jolly: {
        image: Jolly,
        alt: "Jolly Heating & Air homepage hero"    
    },
    Oxford: {
        image: Oxford,
        alt: "Image of the City of Oxford's Home Page"    
    },
    SmartFusion: {
        image: SmartFusion,
        alt: "Image of Smart Fusion's Home Page"    
    },
    Sunshine: {
        image: Sunshine,
        alt: "The Sunshine Center's Homepage hero"    
    },
    Marines: {
        image: Marines,
        alt: "Alabama Marine's homepage hero"    
    },
    Shapiro: {
        image: Shapiro,
        alt: "Shapiro Metals homepage"    
    },
    BREN: {
        image: BREN,
        alt: "Screenshot of the BREN directory on the ACRE CCAP page"    
    },
    WelcomeTable: {
        image: WelcomeTable,
        alt: "Screenshot of the Welcome Table's homepage."    
    },
    UA_Edu: {
        image: UA_Edu,
        alt: "Screenshot of the University of Alabama's College of Education homepage."    
    },
    BWPWS: {
        image: BWPWS,
        alt: "Black Warrior Pet Waste Solutions homepage",    
    },
    Portland: {
        image: Portland,
        alt: "Portland Rescue Mission homepage"    
    },
    JP: {
        image: JP,
        alt: "J & P Construction homepage"
    },
    ARSEA: {
        image: ARSEA,
        alt: "ARSEA APEAL's homepage"
    },
    Barndo: {
        image: Barndo,
        alt: "Homestead Barndominium homepage"
    },
//     ARSEA: {
//         image: ,
//         alt: ""
//     },
}